import dataApi from '../'

export default {

  /**
  * Get organization overview
  */
  getOverview (params) {
    if (params.organizationType) {
      const { organizationType, ...rest } = params
      rest['filterField'] = 'organizationType'
      rest['filterValues'] = organizationType
      params = rest
    }
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/overview',
      params: params
    })
  },

  /**
  * Get parent overview
  */
  getParentOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/parent-overview',
      params: params
    })
  },

  /**
  * Delete unit
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/organization/delete',
      params: params
    })
  },

  /**
  * Get the unit info for edit
  */
  getInforForEdit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/info-for-edit',
      params: params
    })
  },

  /**
   * Gets the job details of the organization
   */
  getJobDetails (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/job-details',
      params: params
    })
  },

  /**
   * Gets the recycler overall report job details of the organization
   */
  getRecyclerOverallJobDetails (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/job-details/recycler-overall',
      params: params
    })
  },

  /**
   * Get the unit info for edit
   */
  updateJobDetails (params, form) {
    return dataApi.request({
      method: 'put',
      url: 'ui/organization/job-details',
      params: params,
      body: form
    })
  },

  /**
   * Update recycler overall job
   */
  updateRecyclerOverallJobDetails (params, form) {
    return dataApi.request({
      method: 'put',
      url: 'ui/organization/job-details/recycler-overall',
      params: params,
      body: form
    })
  },

  /**
  * Add unit
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/organization/add',
      body: params
    })
  },

  /**
  * Edit unit
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/organization/edit',
      body: params
    })
  },

  /**
  * Get simple tree
  */
  getSimpleTree (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/simple-tree',
      body: params
    })
  },

  /**
  * Get lookup CIT
  */
  getLookUpCIT (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/lookUpCIT',
      params: params
    })
  },

  /**
  * Get lookup Maintenance
  */
  getLookUpMaintenance (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/lookUpMaintenance',
      params: params
    })
  },

  /**
  * Get types
  */
  getTypes (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/types',
      params: params
    })
  },

  /**
  * Get my organizations
  */
  getMyOrganization (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/my-organization',
      params: params
    })
  },

  /**
  * Get organization notifications
  */
  getNotifications (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/organization/notifications',
      params: params
    })
  },

  /**
   * Update organization notification
   */
  updateNotification (params, body) {
    return dataApi.request({
      method: 'put',
      url: 'ui/organization/notification',
      params: params,
      body: body
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/organization.js